import React, { useState, useEffect } from 'react';
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import { IoClose } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import BuildAccordion from './BuildAccordion';
import BuildTab from './BuildTab';

function NewBuildSheet() {

    
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        // const handleScroll = () => {
        //     const scrollTop = window.scrollY;
        //     if (scrollTop > 50) {
        //         setScrolled(true);
        //     } else {
        //         setScrolled(false);
        //     }
        // };

        // window.addEventListener('scroll', handleScroll);
        // return () => {
        //     window.removeEventListener('scroll', handleScroll);
        // };
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [selectedButtons, setSelectedButtons] = useState([]);

    // Define an array of button names
    const buttonNames = [
        "Driver", "3 Wood", "5 Wood", "7 Wood", "9 Wood", "2 Hybrid",
        "3 Hybrid", "4 Hybrid", "5 Hybrid", "6 Hybrid", "7 Hybrid", "8 Hybrid",
        "1 Iron", "2 Iron", "3 Iron", "4 Iron", "5 Iron", "6 Iron",
        "7 Iron", "8 Iron", "9 Iron", "GW", "SW", "LW"
    ];

    const handleButtonClick = (index) => {
        if (selectedButtons.includes(index)) {
            setSelectedButtons(selectedButtons.filter(i => i !== index));
        } else {
            setSelectedButtons([...selectedButtons, index]);
        }
    };


    return (
        <>

            <Modal size="lg" centered show={show2} onHide={handleClose2} className="card-radius popup-modal-dark add_club_modal">
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                    <div className="close-modal">
                        <div className="custom-modal-header">
                            <h3 className="text mb-5">4 Iron</h3>
                            <button type="button" className="btn-close" onClick={handleClose2} aria-label="Close">
                                <IoClose />
                            </button>
                        </div>
                    </div>
                    <div className='modal-long-form'>
                        <form className='modal-long-form-inner'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Club Head</label>
                                        </div>
                                        <div className='form-group-input mb-4'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Make</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Model</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Loft</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Loft</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Lie</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Lie</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Club Head Notes</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Club head notes..."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Weight Ports</label>
                                            <div className='form-group-check'>
                                                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group-input'>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option selected>Color</option>
                                                        <option value="1">1 ft.</option>
                                                        <option value="2">2 ft.</option>
                                                        <option value="3">3 ft.</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group-input'>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option selected>Weight</option>
                                                        <option value="1">1 ft.</option>
                                                        <option value="2">2 ft.</option>
                                                        <option value="3">3 ft.</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Weight Port Notes</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Weight port notes..."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Shaft</label>
                                        </div>
                                        <div className='form-group-input mb-4'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Make</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Model</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Weight</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Weight</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Flex</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Flex</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Length</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Length</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Shaft Wrap</label>
                                            <div className='form-group-check'>
                                                <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                                            </div>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Shaft wrap notes..."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Shaft Notes</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Shaft  notes..."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Counter Balance</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                <option selected>Weight</option>
                                                <option value="1">1 ft.</option>
                                                <option value="2">2 ft.</option>
                                                <option value="3">3 ft.</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label'>
                                            <label className='form-label'>Grip</label>
                                        </div>
                                        <div className='row'>
                                            <div className='col-md-6'>
                                                <div className='form-group-input mb-4'>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option selected>Brand</option>
                                                        <option value="1">1 ft.</option>
                                                        <option value="2">2 ft.</option>
                                                        <option value="3">3 ft.</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='form-group-input'>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option selected>Model</option>
                                                        <option value="1">1 ft.</option>
                                                        <option value="2">2 ft.</option>
                                                        <option value="3">3 ft.</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='form-group-input mb-4'>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option selected>Size</option>
                                                        <option value="1">1 ft.</option>
                                                        <option value="2">2 ft.</option>
                                                        <option value="3">3 ft.</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-md-12'>
                                                <div className='form-group-input'>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                        <option selected>Label</option>
                                                        <option value="1">1 ft.</option>
                                                        <option value="2">2 ft.</option>
                                                        <option value="3">3 ft.</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Grip Notes</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Grip notes..."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='form-group-label d-flex align-items-center justify-content-between'>
                                            <label className='form-label'>Ferrule</label>
                                        </div>
                                        <div className='form-group-input'>
                                            <textarea class="form-control dashboard-text-area" id="exampleFormControlTextarea1" rows="8" placeholder="Ferrule notes..."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='full-width-btn'>
                                    <button className="btn btn_default bg-white text-dark btn_disabled" type="submit">
                                        Add Club
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-dashboard-header-title">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>New Build Sheet</h3>
                                        </div>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="row">
                                            <div className="col-md-8 dashboard_2 study_guide_open db_col">
                                                <div className="build_number_box">
                                                    <div className="build_number_box_inner">
                                                        <div className="build_title">
                                                            Build Number
                                                        </div>
                                                        <div className="build_number">
                                                            235
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="btn-box-section btn-inline-box">
                                                    <button className="btn btn-primary btn-remove">Remove Build</button>
                                                    <button className="btn btn-primary btn-create">Save Build</button>
                                                </div>
                                            </div>
                                            <div className={`col-md-4 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                <div className="fix_sec_view container-fluid ps-0">
                                                    <div className="btn-box-section mt-0">
                                                        <button className="btn btn-primary btn-create" onClick={handleShow2}>New Build</button>
                                                    </div>
                                                    <BuildTab />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default NewBuildSheet;